// @flow
import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import Loading from 'app/common/components/Loader';
import PlainIcon, { iconTypes } from 'app/common/ui-next/plain-icon';

import styles from './EmptyOrder.module.scss';;


type Props = {
  className?: string,
  loading?: boolean,
}

const EmptyOrder = ({ className, loading }: Props) => {
  const { t } = useTranslation('cafeteria');

  if (loading) {
    return (
      <Loading />
    );
  }

  return (
    <div className={cn(styles.root, className)}>
      <PlainIcon type={iconTypes.MOUSE} />
      <div className={styles.text}>
        {t(
          'order_form_empty_order_text',
          'Нажмите на выбранное блюдо из окна слева, чтобы добавить его к заказу',
        )}
      </div>
    </div>
  );
};

export default EmptyOrder;
